// // // src/hooks/useAuth.js

// // import { useState, useEffect } from 'react';
// // import {
// //   getUser,
// //   getToken,
// //   isLoggedIn,
// //   logout,
// //   isTokenExpired,
// //   getUserRole,
// // } from './auth'; // or '../utils/auth' depending on your file location

// // const useAuth = () => {
// //   const [user, setUser] = useState(getUser());
// //   const [token, setToken] = useState(getToken());
// //   const [authenticated, setAuthenticated] = useState(isLoggedIn());

// //   useEffect(() => {
// //     // check token expiry on mount
// //     if (isTokenExpired()) {
// //       logout();
// //     }
// //   }, []);

// //   return {
// //     user,
// //     token,
// //     authenticated,
// //     logout,
// //     role: getUserRole(),
// //   };
// // };

// // export default useAuth;


// // src/hooks/useAuth.js

// import { useState, useEffect } from 'react';
// import {
//   getUser,
//   getToken,
//   isLoggedIn,
//   logout,
//   isTokenExpired
// } from './auth'; // Adjust path if needed

// const useAuth = () => {
//   const [user, setUser] = useState(getUser());
//   const [token, setToken] = useState(getToken());
//   const [authenticated, setAuthenticated] = useState(isLoggedIn());

//   useEffect(() => {
//     if (isTokenExpired()) {
//       logout();
//     }
//   }, []);

//   return {
//     user,
//     token,
//     authenticated,
//     logout,

//     // Spread all user fields individually for convenience
//     id: user?.id || null,
//     email: user?.email || '',
//     password: user?.password || '',
//     fullName: user?.fullName || '',
//     phoneNumber: user?.phoneNumber || '',
//     speciality: user?.speciality || '',
//     gender: user?.gender || '',
//     dateOfJoining: user?.dateOfJoining || '',
//     profileImg: user?.profileImg || '',
//     contacts: user?.contacts || [],
//     roles: user?.roles || [],
//     role: user?.roles?.[0]?.name || '',
//   };
// };

// export default useAuth;

// src/hooks/useAuth.js

import { useState, useEffect } from 'react';
import {
  getUser,
  getToken,
  isLoggedIn,
  logout,
  isTokenExpired,
  getUserRole,
  getUserRoles
} from './auth'; // adjust if your path differs

const useAuth = () => {
  const [user, setUser] = useState(getUser());
  const [token, setToken] = useState(getToken());
  const [authenticated, setAuthenticated] = useState(isLoggedIn());

  useEffect(() => {
    // Re-check expiry every load
    if (isTokenExpired()) {
      logout();
    } else {
      setUser(getUser());
      setToken(getToken());
      setAuthenticated(true);
    }
  }, []);

  return {
    user,
    token,
    authenticated,
    logout,
    role: getUserRole(),
    roles: getUserRoles()
  };
};

export default useAuth;


